import React from "react";
import classes from "./Reviews.module.css";
import ImageSlider from "./ImageSlider";
import Button from "react-bootstrap/Button";

import review1 from "../Assets/review1.png";
import review2 from "../Assets/review2.png";
import review3 from "../Assets/review3.png";
import review4 from "../Assets/review4.png";
import review5 from "../Assets/review5.png";

const Reviews = () => {
  const slides = [
    { url: review1, title: "review 1" },
    { url: review2, title: "review 2" },
    { url: review3, title: "review 3" },
    { url: review4, title: "review 4" },
    { url: review5, title: "review 5" },
  ];
  return (
    <div className={classes.Intro}>
      <h1 className={classes.focusLine}>
        <span>OUR REVIEWS</span>
      </h1>
      <div className={classes.container1}>
        <div className={classes.carousel}>
          <ImageSlider className={classes.slider} slides={slides} />
        </div>
        <div className={classes.review}>
          <a class="Book" href="https://www.google.com/maps/place/Dr.+Mackensie+Jordan,+DC/@44.0737108,-79.4320943,15z/data=!4m7!3m6!1s0x0:0xf7ec117f37dbf952!8m2!3d44.0737108!4d-79.4320943!9m1!1b1">
            <Button
              variant="default"
              style={{
                background: "white",
                color: "#000",
                width: "200px",
                height: "50px",
                fontWeight: "bold",
              }}
            >
              REVIEW US!
            </Button>
          </a>
        </div>
      </div>
    </div>
  );
};

export default Reviews;

/**
 * <button class="carousel-button prev">&#60;</button>
          <button class="carousel=button next">&#62;</button>
          <ul className="list-unstyled">
            <li className={classes.slides} data-active>
              <img src={review1} alt={sliders[0].url} />
            </li>
            <li className={classes.slides}>
              <img src={review2} alt={sliders[1].url} />
            </li>
            <li className={classes.slides}>
              <img src={review3} alt={sliders[2].url} />
            </li>
            <li className={classes.slides}>
              <img src={review4} alt={sliders[3].url} />
            </li>
            <li className={classes.slides}>
              <img src={review5} alt={sliders[4].url} />
            </li>
          </ul>
 */
